import React, { useEffect, useState } from 'react';
import { Box, CardContent, CardMedia, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link,useNavigate } from 'react-router-dom';
import { demoProfilePicture } from '../utils/constants';

const ChannelCard = ({ channelDetail, marginTop }) => {
  // const [selectedCategory, setSelectedCategory] = useState("");
    useEffect(() => {
      console.log(channelDetail)
    }, []);
    const navigate = useNavigate();
    const onhandleSubmit = () => {
        // e.preventDefault();
        // console.log(category)
        // setSelectedCategory(category)
        navigate(`/channel/${channelDetail?.id?.channelId}`);
    };
  
  
  
  return(
  <Box
    sx={{
      boxShadow: 'none',
      borderRadius: '20px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'start',
      // width: { xs: '356px', md: '320px' },
      height: '226px',
      margin: 'auto',
      marginTop,
    }}
  >
    <Box sx={{"cursor":"pointer"}}onClick={()=>onhandleSubmit()}>
      <CardContent sx={{ display: 'flex', flexDirection: 'row',alignItems:"start", justifyContent: 'start', textAlign: 'left', color: '#fff' }}>
        <CardMedia
          image={channelDetail?.snippet?.thumbnails?.high?.url || demoProfilePicture}
          alt={channelDetail?.snippet?.title}
          sx={{ margin:2, padding:2, borderRadius: '50%', height: '130px', width: '130px', border: '1px solid #e3e3e3' }}
        />
        <Box margin="20px" width="50vw" >
          <Typography  align='left' variant="h6">
            {channelDetail?.snippet?.title}{' '}
            <CheckCircleIcon sx={{ fontSize: '14px', color: 'gray', ml: '5px' }} />
          </Typography>

            <Typography align='left' color= '#aaa' variant="h10">
              {channelDetail?.snippet?.description}{' '}
            </Typography>


          

        </Box>
        


        {channelDetail?.statistics?.subscriberCount && (
          <Typography sx={{ fontSize: '15px', fontWeight: 500, color: 'gray' }}>
            {parseInt(channelDetail?.statistics?.subscriberCount).toLocaleString('en-US')} Subscribers
          </Typography>
        )}
      </CardContent>
    </Box>
  </Box>
)};

export default ChannelCard;